import { appHttpRequest } from '@/utils/AppHttpRequest';
import { IMaintenanceDetail } from './vrmNewBillmaintenanceType';

class MaintenanceService {
	async one(id: string) {
		const apiUrl = `/vrm2/maintenance/findById/${id}`;
		return await appHttpRequest.get<IMaintenanceDetail>(apiUrl);
	}
}
export const maintenanceService = new MaintenanceService();
